module.exports = __webpack_public_path__ + "static/img/d-bg.b68d4a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/download/d-bg.png
// module id = PvEv
// module chunks = 0